module.exports = "/_next/static/images/search_bg_17-728842c33c037993a99718e2c2e90364.jpg";